import JobCard from './JobCard';

/**
 * A titled, horizontally scroll-snapping row of JobCards. Renders nothing when
 * there are no jobs. Used on /jobs (editorial rails) and the dashboard.
 */
export default function JobRail({ title, hint, jobs, matchScores = {}, cardWidth = 300, grid = false, skillFreq }) {
  if (!jobs || jobs.length === 0) return null;

  const containerStyle = grid
    ? {
        // Wrapping grid — cards fill the width in rows (no horizontal scroll)
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fill, minmax(${cardWidth}px, 1fr))`,
        gap: 16,
        margin: '0 -4px',
        padding: '4px',
      }
    : {
        // Single horizontal scroll-snap row
        display: 'grid',
        gridAutoFlow: 'column',
        gridAutoColumns: `${cardWidth}px`,
        gap: 16,
        overflowX: 'auto',
        scrollSnapType: 'x mandatory',
        paddingBottom: 6,
        margin: '0 -4px',
        padding: '4px',
      };

  return (
    <section style={{ marginBottom: 32 }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, marginBottom: 12 }}>
        <h2 style={{ fontFamily: 'var(--tandm-font-display)', fontSize: 19, fontWeight: 500, color: 'var(--tandm-ink)', letterSpacing: '-0.02em', margin: 0 }}>
          {title}
        </h2>
        {hint && <span style={{ fontSize: 12, color: 'var(--tandm-muted)' }}>{hint}</span>}
        <span style={{ marginLeft: 'auto', fontSize: 12, fontWeight: 600, color: 'var(--tandm-faint)' }}>{jobs.length}</span>
      </div>

      <div className="job-rail" style={containerStyle}>
        {jobs.map((job) => (
          <div key={job.id} style={{ ...(grid ? {} : { scrollSnapAlign: 'start' }), display: 'flex' }}>
            <JobCard job={job} matchScore={matchScores[String(job.id)] ?? matchScores[job.id] ?? null} skillFreq={skillFreq} />
          </div>
        ))}
      </div>
    </section>
  );
}
